import React, { useEffect, useState } from "react";
import { Row, Col, Button, ProgressBar } from 'react-bootstrap';
import { Input } from './';
import { setRating } from '../../utils/utils';

function AddReviewRating({ courseTitle, onHandelSave, ratingValue = 0, reviewValue = '' }) {
    const [rating, setRatingValue] = useState(ratingValue);
    const [review, setReview] = useState(reviewValue);
    const [error, setError] = useState(null);
    const handleReviewChange = (e) => {
        setReview(e.target.value);
    }
    const handeSave = () => {
        if (!rating) {
            setError('Please select a rating');
            return;
        }
        onHandelSave(rating, review);
    }
    useEffect(() => {
        setError(null);
    }, [rating, review]);

    return (
        <Row>
            <Col md={12} sm={12} className="mb-4" style={{ borderRight: 'solid 2px #dbd7d6ff' }}>
                <h5 className="mb-3">{courseTitle}</h5>
                {setRating(rating, setRatingValue, { fontSize: '1.2rem', marginRight: '16px' })}
            </Col>
            <Col md={12} sm={12}>
                <Input
                    label="Review"
                    as="textarea"
                    rows={4}
                    placeholder="Write your review here..."
                    value={review}
                    onChange={handleReviewChange}
                />
                <Button type="submit" title="Save" className="save-btn px-5" onClick={handeSave}>Save</Button>
            </Col>
            {error && <Col md={12} sm={12} className="text-danger">{error}</Col>}
        </Row>
    );
}

export default AddReviewRating;